/**
 * The language control in the top bar, beside the theme.
 *
 * The language used to be decided once, at start-up, from the browser's list —
 * and then could not be changed. `changeLocale` already moves the strings, the
 * stored choice and the document's `lang` and `dir` together, and the stored
 * choice wins over the browser on the next visit, so this only has to ask.
 *
 * Only what the back office is translated into: its screens ship in English
 * and French. Offering Spanish or Arabic here would give a page of raw keys.
 */

import { useTranslation } from "react-i18next";
import { changeLocale, type Locale } from "@hardauto/core-i18n";
import { Select } from "@hardauto/core-ui";

const OFFERED: readonly { code: Locale; label: string }[] = [
  { code: "en", label: "English" },
  { code: "fr", label: "Français" },
];

export function LanguageSwitcher() {
  const { t, i18n } = useTranslation("backoffice");
  // `fr-CA` is French here, as in the negotiation.
  const base = (i18n.language || "en").toLowerCase().split(/[-_]/)[0];
  const current = OFFERED.some((item) => item.code === base) ? base : "en";

  return (
    <Select
      className="hardauto-header__language"
      aria-label={t("shell.language")}
      value={current}
      onChange={(event) => {
        void changeLocale(i18n, event.target.value as Locale);
      }}
    >
      {OFFERED.map((item) => (
        <option key={item.code} value={item.code}>
          {item.label}
        </option>
      ))}
    </Select>
  );
}
